module.exports = __webpack_public_path__ + "img/oracle-fusion-erpimg-8.ae76169a.png";